import { ArsTableHeaderCell } from "../interface";
import { isArsTableColumnGroupCell } from "./isArsTableColumnGroupCell";
import { isArsTableColumnGroupLabel } from "./isArsTableColumnGroupLabel";
import { isArsTableColumnOperationCell } from "./isArsTableColumnOperationCell";
// import { isArsTableEmptyRowHeaderCell } from "./isArsTableEmptyRowHeaderCell";
import { isArsTableRowHeaderCell } from "./isArsTableRowHeaderCell";

/**
 * Type guard for ArsTableHeaderCell, which can be any of the header cell types in the table.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cell's displayContent and annotationContent
 * @returns - True if the object is an ArsTableHeaderCell, false otherwise
 */
export const isArsTableHeaderCell = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableHeaderCell<T> =>
  isArsTableColumnGroupCell(obj, isT) ||
  isArsTableColumnGroupLabel(obj, isT) ||
  isArsTableColumnOperationCell(obj, isT) ||
  isArsTableRowHeaderCell(obj, isT);
